import { I18n } from '@calendly/i18n'
import { Badge, BADGE_TYPE_NEUTRAL } from '@calendly/ui/components/badge'
import { BareButton } from '@calendly/ui/components/bare-button'
import { IconGripVertical } from '@calendly/ui/components/glyphs/IconGripVertical'
import { LabelText } from '@calendly/ui/components/typography'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorIconDisabled } from '@calendly/ui/theme'
import classNames from 'classnames'

import {
  decorativeDragIconCss,
  systemQuestionLabelCss,
  systemQuestionLeadingCss,
  systemQuestionRowCss,
  systemQuestionRowInteractiveCss,
} from './styles'

export const SystemQuestionRow = ({
  label,
  onClick,
  disabled = false,
}) => {
  const isInteractive = Boolean(onClick) && !disabled
  const testId = `system-question-row-${label.toLowerCase()}`

  const content = (
    <>
      <span className={systemQuestionLeadingCss}>
        <span className={decorativeDragIconCss} aria-hidden>
          <UiIcon color={colorIconDisabled} icon={IconGripVertical} size="medium" title="" />
        </span>
        <LabelText className={systemQuestionLabelCss} size="large">{label}</LabelText>
      </span>
      <Badge type={BADGE_TYPE_NEUTRAL}>
        {I18n.t('publisher.event_types.invitee_questions.required_label')}
      </Badge>
    </>
  )

  if (isInteractive) {
    return (
      <BareButton
        aria-label={label}
        className={classNames(systemQuestionRowCss, systemQuestionRowInteractiveCss)}
        data-testid={testId}
        onClick={onClick}
      >
        {content}
      </BareButton>
    )
  }

  return (
    <div className={systemQuestionRowCss} data-testid={testId}>
      {content}
    </div>
  )
}
